
      const GTM_ID = import.meta.env.VITE_GOOGLE_TAG_MANAGER_SOURCE_ID_WMT;
      if (GTM_ID) {
        const iframe = document.createElement("iframe");
        iframe.src = `https://www.googletagmanager.com/ns.html?id=${GTM_ID}`;
        iframe.height = "0";
        iframe.width = "0";
        iframe.style.display = "none";
        iframe.style.visibility = "hidden";
        document.getElementById("gtm-noscript-placeholder").appendChild(iframe);
      }
    